module.exports = __webpack_public_path__ + "img/load_today_cons.48e6897c.svg";